import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { resizeImage } from '../../../utils';
const StyledImg = styled('img') `
  height: 160px;
  width: 100%;
  object-fit: cover;
  object-position: center center;
`;
const StyledIconButton = styled(IconButton) `
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }
`;
const PhotoCard = ({ index, url, onImageDelete, innerRef, provided }) => {
    return (_jsxs(Box, { position: "relative", sx: { flex: '0 1 100%' }, ref: innerRef, ...(provided?.draggableProps ?? {}), children: [_jsx(StyledImg, { src: resizeImage(url, 500), alt: `Photo ${index}`, draggable: "false" // needed to prevent native img dragging from confusing user
             }), _jsxs(Box, { position: "absolute", display: "flex", gap: 0.5, sx: {
                    top: 0,
                    right: 0,
                    p: 0.5,
                }, children: [onImageDelete && (_jsx(StyledIconButton, { size: "small", onClick: () => onImageDelete(index), children: _jsx(CloseIcon, { fontSize: "small" }) })), provided?.dragHandleProps && (_jsx(StyledIconButton, { size: "small", ...provided.dragHandleProps, children: _jsx(DragIndicatorIcon, { fontSize: "small" }) }))] })] }));
};
export default PhotoCard;
//# sourceMappingURL=PhotoCard.js.map